import React, { Component } from 'react'
import { Button, Col, DatePicker, Form, Icon, Input, InputNumber, message, Modal, Row, Select, Upload,Radio } from 'antd'
import moment from "moment"
import { api, app, config } from "../../app"
import locale from 'antd/lib/date-picker/locale/zh_CN'
import BraftEditor from 'braft-editor'
import { ContentUtils } from 'braft-utils'
import { ImageUtils } from 'braft-finder'
import 'braft-editor/dist/index.css'
import PlayerSelector from "../../components/PlayerSelector"

const FormItem = Form.Item
const Option = Select.Option
const TextArea = Input.TextArea

/**
 * 表单排版
 * @param span
 * @returns {{labelCol: {span: number}, wrapperCol: {span: (*|number), offset: number}}}
 * @constructor
 */
function FormItemLayout (span) {
    return {
        labelCol: { span: 7 },
        wrapperCol: { span: span || 16, offset: 1 }
    }
}

/**
 * 禁止选择的时间
 * @param current
 * @returns {*|boolean}
 */
function disabledDate (current) {
    return current && current < moment().endOf('day')
}

/**
 *格式参数
 * @param form
 * @returns {{indexno: *, account: *, trainame: *, class_id: *, train_site: *, train_teacher: *, grade: *, train_number: number | *, train_ppe: *, train_equip: *, train_content: *, apply_time: string, price: number | *}}
 * @constructor
 */
function FormatValues (form, is_class) {
    const params = {
        is_class,
        indexno: app.getData("indexno"),
        account: app.getData("account"),
        trainame: form.trainame,
        class_id: form.class_id,
        train_teacher: form.train_teacher,
        grade: form.grade,
        train_number: form.train_number,
        train_ppe: form.train_ppe,
        train_equip: form.train_equip,
        train_content: form.train_content.toHTML(),
        apply_time: form.apply_time.format("YYYY-MM-DD HH:00:00"),
        price: form.price,
        is_certificate: form.is_certificate
    }
    const { range_date, train_day, browse_img, details_img, train_site } = form
    if (is_class === '1') {
        params.train_day = train_day
    } else {
        params.train_site = train_site
        params.startdate = range_date[0].format("YYYY-MM-DD HH:00:00")
        params.endate = range_date[1].format("YYYY-MM-DD HH:00:00")
    }
    if (browse_img[0].response && browse_img[0].response.flag === 1) {
        params.browse_url = browse_img[0].response.data.url
    }
    const imgs = []
    for (let i = 0; i < details_img.length; i++) {
        const res = details_img[i].response
        if (res && res.flag === 1) {
            imgs.push(res.data.url)
        }
    }
    params.details_url = imgs.join(":::")
    return params
}

/**
 * 上传之前2
 * @param file
 */
function beforeUpload2 (file) {
    const isLt2M = file.size / 1024 / 1024 < 2, types = ['image/png', 'image/jpeg', 'image/gif', 'image/webp']
    if (!isLt2M) {
        app.alert('图片最大2MB！', 'error')
        return Promise.reject(false)
    } else if (types.indexOf(file.type) === -1) {
        app.alert('仅支持上传【.png, .jpg, .gif】！', 'error')
        return Promise.reject(false)
    }

    return Promise.resolve(true)
}

class NTrainRelease extends Component {

    constructor (props) {
        super(props)
        this.state = {
            model_visible: false,
            gradeList: [],
            is_class: '0',
        }
    }

    async componentDidMount () {
        this._isMounted = true
        const train_id = this.props.match.params.id
        console.log(app.getData('rights'), app.getData('train_nationwide_rights'))
        if (train_id) {
            await this.dataSource(train_id)
        } else if (app.getData('rights') === 1 || app.getData('train_nationwide_rights') === '1') {
            const self = this
            Modal.confirm({
                title: '是否分班？',
                content: '注：分班培训，队员成功报名后，由发布人选择队员进行分班分期培训，另设培训开始时间、结束时间和培训地点。',
                okText: '是',
                cancelText: '否',
                style: {
                    top: '35%'
                },
                keyboard: false,
                maskClosable: false,
                onOk () {
                    self.setData({ is_class: '1' })
                },
                onCancel () {
                    self.setData({ is_class: '0' })
                },
            })
        }
        await this.getTrainGrade()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    /**
     * 预览HTML
     **/
    buildPreviewHtml = (html) => {
        return `
              <!Doctype html>
              <html>
                <head>
                  <title>预览内容</title>
                  <style>
                    html,body{
                      height: 100%;
                      margin: 0;
                      padding: 0;
                      overflow: auto;
                      background-color: #f1f2f3;
                    }
                    .container{
                      box-sizing: border-box;
                      width: 1000px;
                      max-width: 100%;
                      min-height: 100%;
                      margin: 0 auto;
                      padding: 30px 20px;
                      overflow: hidden;
                      background-color: #fff;
                      border-right: solid 1px #eee;
                      border-left: solid 1px #eee;
                    }
                    .container img,
                    .container audio,
                    .container video{
                      max-width: 100%;
                      height: auto;
                    }
                    .container p{
                      white-space: pre-wrap;
                      min-height: 1em;
                    }
                    .container pre{
                      padding: 15px;
                      background-color: #f1f1f1;
                      border-radius: 5px;
                    }
                    .container blockquote{
                      margin: 0;
                      padding: 15px;
                      background-color: #f1f1f1;
                      border-left: 3px solid #d1d1d1;
                    }
                  </style>
                </head>
                <body>
                  <div class="container">${html}</div>
                </body>
              </html>
            `
    }

    /**
     * 预览
     */
    handlePreview = () => {
        const html = this.props.form.getFieldValue('train_content').toHTML()
        console.log(html)
        if (!html || html === '<p></p>') {
            app.alert('您填写内容后才可预览！', 'warn')
            return
        }
        if (window.previewWindow) {
            window.previewWindow.close()
        }
        window.previewWindow = window.open()
        window.previewWindow.document.write(html)
        window.previewWindow.document.close()
    }

    /**
     * 编辑器图片上传
     * @param file
     * @returns {boolean}
     */
    editorUploadHandler = ({ file }) => {
        if (!file) {
            return false
        }
        if (file.status === 'done' && file.response && file.response.flag === 1) {
            this.props.form.setFieldsValue({
                train_content: ContentUtils.insertMedias(this.props.form.getFieldValue('train_content'), [{
                    type: 'IMAGE',
                    url: config.imgUrl + file.response.data.url
                }])
            })
        } else if (file.status === 'error') {
            app.alert('上传失败', 'error')
        }
    }

    /**
     * 数据
     * @param train_id
     * @returns {Promise<void>}
     */
    dataSource = async (train_id) => {
        message.loading("正在加载~", 0)
        const params = {
            train_id,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let { flag, data, msg } = await app.post(api.PublishTrainDetails, params)
        if (flag === 1) {
            const form = {
                trainame: data.trainame,
                train_day: data.train_day,
                train_site: data.train_site,
                train_teacher: data.train_teacher,
                class_id: data.class_id,
                grade: data.grade,
                train_number: parseInt(data.train_number),
                train_ppe: data.train_ppe,
                train_equip: data.train_equip,
                train_content: BraftEditor.createEditorState(data.train_content),
                apply_time: moment(data.apply_time, "YYYY-MM-DD HH:mm:ss"),
                is_certificate: data.is_certificate ? (data.is_certificate + '') : undefined,
                price: parseFloat(data.train_price),
                details_img: (data.details_images || []).map((img, index) => {
                    return {
                        uid: 'detail-img-' + index,
                        name: "详情图片" + (index + 1),
                        response: { data: { url: img }, flag: 1 },
                        thumbUrl: config.imgUrl + img,
                    }
                }),
                browse_img: [{
                    uid: train_id,
                    name: "阅览图片",
                    response: { data: { url: data.browse_images }, flag: 1 },
                    thumbUrl: config.imgUrl + data.browse_images,
                }],
            }
            if (data.is_class === '1') {
                form.train_day = data.train_day
            } else {
                form.range_date = [moment(data.startdate, "YYYY-MM-DD HH:mm:ss"), moment(data.endate, "YYYY-MM-DD HH:mm:ss")]
            }
            message.destroy()
            await this.setData({ train_id, is_class: data.is_class, loading: false })
            this.props.form.setFieldsValue(form)
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 设置值
     * @param obj
     */
    setData = (obj) => app.setStateSync(this, obj)

    /**
     * 培训级别
     * @returns {Promise<void>}
     */
    getTrainGrade = async () => {
        let params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let { flag, data, msg } = await app.post(api.TrainGrade, params)
        if (flag === 1) {
            this.setData({ gradeList: data })
        } else {
            app.alert(msg, "warn")
        }
    }

    /**
     * 获取分类集合
     * @returns {Promise<void>}
     */
    getClassList = async () => {
        let { flag, data, msg } = await app.post(api.HomeClassList)
        if (this._isMounted) {
            if (flag !== 1) {
                app.alert(msg, "warn")
                data = []
            }
            return data
        }
    }

    /**
     * 规范文件
     * @param e
     * @returns {*}
     */
    normFile = (e) => {
        if (Array.isArray(e)) {
            return e
        }
        return e && e.fileList
    }

    /**
     * 修改
     * @param params
     */
    handleUpdate = async (params) => {
        const { loading, update_loading } = this.state
        if (update_loading && loading) return
        await this.setData({ update_loading: true })
        params.train_id = this.state.train_id
        const { flag, msg } = await app.post(api.TrainEdit, params)
        await this.setData({ update_loading: false })
        if (flag === 1) {
            app.alert("修改成功", "success")
            this.handleBack()
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 表单提交
     * @param e
     */
    handleSubmit = (e) => {
        e.preventDefault()
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                const { browse_img, details_img } = values
                if (!browse_img[0].response || browse_img[0].response.flag !== 1) {
                    app.alert("阅览图片未上传成功！", "error")
                } else if (!details_img[0].response || details_img[0].response.flag !== 1) {
                    app.alert("详情图片未上传成功！", "error")
                } else {
                    const { train_id } = this.state
                    if (train_id) {
                        this.handleUpdate(FormatValues(values, this.state.is_class))
                    } else {
                        this.openSelPlayerModal()
                    }
                }
            }
        })
    }

    /**
     * 添加
     */
    handleEdit = async (p) => {
        let form = this.props.form.getFieldsValue(),
            params = Object.assign(this.pSelector.getValue(), FormatValues(form, this.state.is_class))
        const { flag, msg } = await app.post(api.TrainCreate, params)
        if (flag === 1) {
            app.alert("发布成功", "success")
            this.handleBack()
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 添加培训人员
     */
    handleAddPlayer = async (train_id, p) => {
        let params = {
            train_id,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        params = Object.assign(p, params)
        let { flag, msg } = await app.post(api.AddTrainUser, params)
        if (flag === 1) {
            app.alert("添加成功", "success")
            this.closeSelPlayerModal()
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 重置表单
     */
    handleReset = () => {
        this.props.form.resetFields()
    }

    /**
     * 验证截止时间
     **/
    handleConfirmApplyDate = (rule, value, callback) => {
        const { getFieldValue } = this.props.form
        const range_date = getFieldValue("range_date")
        if (value && range_date && range_date.length > 0) {
            if (value.isAfter(range_date[0])) {
                callback('截止报名时间不能大于培训开始时间！')
            }
        }
        // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
        callback()
    }

    /**
     * 验证开始时间
     **/
    handleConfirmStartDate = (rule, value, callback) => {
        const { getFieldValue } = this.props.form
        const apply_time = getFieldValue("apply_time")
        if (value && value.length > 0 && apply_time) {
            if (apply_time.isAfter(value[0])) {
                callback('培训开始时间不能小于截止报名时间！')
            }
        }
        // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
        callback()
    }

    /**
     * 返回
     **/
    handleBack = () => {
        const { history } = this.props
        history.replace('/notice/train-releaseList')
    }

    /**
     * 选人成功
     * @param result
     * @returns {Promise<void>}
     */
    handleSelPlayerSuccess = async () => {
        const p = this.pSelector.getValue()
        await this.setData({submit_loading: true})
        let { train_id } = this.state
        if (train_id) {
            await this.handleAddPlayer(train_id, p)
        } else {
            await this.handleEdit(p)
        }
        await this.setData({submit_loading: false})
    }

    /**
     * 打开选人对话框
     */
    openSelPlayerModal = () => {
        this.setData({ model_visible: true })
    }

    /**
     * 关闭选人对话框
     */
    closeSelPlayerModal = () => {
        this.setData({ model_visible: false })
    }

    onPlayerSelectorRef = (ref) => {
        this.pSelector = ref
    }

    render () {
        const { train_id, update_loading, model_visible, gradeList, is_class, submit_loading } = this.state,
            { getFieldDecorator, getFieldValue } = this.props.form,
            grade = getFieldValue('grade')
        const excludeControls = ['media', 'emoji', 'code'], extendControls = [
            {
                key: 'custom-button',
                type: 'button',
                text: '预览',
                onClick: this.handlePreview
            },
            {
                key: 'antd-uploader',
                type: 'component',
                component: (
                    <Upload
                        accept="image/png,image/jpeg,image/gif"
                        showUploadList={false}
                        action={config.serverUrl + api.ImageUpload}
                        beforeUpload={beforeUpload2}
                        data={{
                            token: app.getData('token'),
                            indexno: app.getData('indexno'),
                            account: app.getData('account'),
                            upload_type: 'train'
                        }}
                        name="image"
                        onChange={(file) => this.editorUploadHandler(file)}
                    >
                        {/* 这里的按钮最好加上type="button"，以避免在表单容器中触发表单提交，用Antd的Button组件则无需如此 */}
                        <button type="button" className="control-item button upload-button" data-title="插入图片">
                            <Icon type="picture" theme="filled"/>
                        </button>
                    </Upload>
                )
            }
        ]
        return (
            <div className="n-page notice-train-release">
                <div className="page-title">发布培训</div>
                <div className="page-content">
                    <div className="items">
                        <Form onSubmit={this.handleSubmit}>
                            <Row>
                                <Col span={11}>
                                    <FormItem
                                        label="培训课程"
                                        {...FormItemLayout()}
                                    >
                                        {getFieldDecorator('trainame', {
                                            rules: [
                                                { required: true, message: '请填写培训课程' },
                                            ],
                                        })(
                                            <Input placeholder="填写培训课程" maxLength={20}/>
                                        )}
                                    </FormItem>
                                    <FormItem
                                        label="培训分类"
                                        {...FormItemLayout()}
                                    >
                                        {getFieldDecorator('class_id', {
                                            rules: [
                                                { required: true, message: '请选择培训分类' },
                                            ],
                                        })(
                                            <Select
                                                placeholder="选择培训分类"
                                                notFoundContent="无记录"
                                                optionFilterProp="children"
                                            >
                                                <Option key="1">内部培训</Option>
                                                <Option key="2">外部培训</Option>
                                                <Option key="3">特定培训</Option>
                                            </Select>
                                        )}
                                    </FormItem>
                                    {
                                        is_class === '1' ? (
                                            <FormItem
                                                label="培训周期"
                                                {...FormItemLayout()}
                                            >
                                                {getFieldDecorator('train_day', {
                                                    rules: [
                                                        { required: true, message: '请选择培训时间' },
                                                    ],
                                                })(
                                                    <InputNumber min={1}/>
                                                )}
                                                <span className="ant-form-text"> 天</span>
                                            </FormItem>
                                        ) : (
                                            [
                                                (
                                                    <FormItem
                                                        key="1"
                                                        label="培训时间"
                                                        {...FormItemLayout()}
                                                    >
                                                        {getFieldDecorator('range_date', {
                                                            rules: [
                                                                { required: true, message: '请选择培训时间' },
                                                                { validator: this.handleConfirmStartDate },
                                                            ],
                                                        })(
                                                            <DatePicker.RangePicker
                                                                showTime={{ format: "YYYY-MM-DD HH" }}
                                                                disabledDate={disabledDate}
                                                                format="YYYY年MM月DD日 HH时"
                                                                placeholder={['开始日期', '结束日期']}
                                                                style={{ width: '100%' }}
                                                                locale={locale}
                                                            />
                                                        )}
                                                    </FormItem>
                                                ),
                                                (

                                                    <FormItem
                                                        key="2"
                                                        label="培训地点"
                                                        {...FormItemLayout()}
                                                    >
                                                        {getFieldDecorator('train_site', {
                                                            rules: [{ required: true, message: '请填写培训地点' }],
                                                        })(
                                                            <Input placeholder="填写培训地点"/>
                                                        )}
                                                    </FormItem>
                                                )]
                                        )
                                    }
                                    <FormItem
                                        label="培训师"
                                        {...FormItemLayout()}
                                    >
                                        {getFieldDecorator('train_teacher', {
                                            rules: [{ required: true, message: '请填写培训师' }],
                                        })(
                                            <Input placeholder="填写培训师"/>
                                        )}
                                    </FormItem>
                                    <FormItem
                                        label="培训级别"
                                        {...FormItemLayout()}
                                    >
                                        {getFieldDecorator('grade', {
                                            rules: [{ required: true, message: '请选择培训级别' }],
                                        })(
                                            <Select placeholder="选择培训级别">
                                                {
                                                    is_class === '1' ?
                                                        (<Option value="全国">全国</Option>) :
                                                        gradeList.map((grade, i) => {
                                                            return (
                                                                <Option key={i}
                                                                        value={grade.grade_name}>{grade.grade_name}</Option>
                                                            )
                                                        })
                                                }
                                            </Select>
                                        )}
                                    </FormItem>
                                    <FormItem
                                        label="培训截止报名时间"
                                        {...FormItemLayout()}
                                    >
                                        {getFieldDecorator('apply_time', {
                                            rules: [
                                                { required: true, message: '请选择截止报名时间' },
                                                { validator: this.handleConfirmApplyDate },
                                            ],
                                        })(
                                            <DatePicker
                                                locale={locale}
                                                disabledDate={disabledDate}
                                                showTime={{ format: "YYYY-MM-DD HH" }}
                                                format="YYYY年MM月DD日 HH时"
                                                placeholder="选择截止报名时间"
                                                style={{ width: '100%' }}
                                            />
                                        )}
                                    </FormItem>
                                    {/*<FormItem*/}
                                        {/*label="培训人数"*/}
                                        {/*{...FormItemLayout(6)}*/}
                                    {/*>*/}
                                        {/*{getFieldDecorator('train_number', {*/}
                                            {/*rules: [{ required: true, message: '请填写培训人数' }],*/}
                                        {/*})(*/}
                                            {/*<InputNumber style={{ width: "100%" }} min={1} placeholder="填写培训人数"/>*/}
                                        {/*)}*/}
                                    {/*</FormItem>*/}
                                    <FormItem
                                        label="培训价格（￥）"
                                        {...FormItemLayout(6)}
                                    >
                                        {getFieldDecorator('price', {
                                            rules: [{ required: true, message: '请填写培训价格' }],
                                        })(
                                            <InputNumber precision={2} min={0} style={{ width: "100%" }}
                                                         placeholder="填写培训价格"/>
                                        )}
                                    </FormItem>
                                </Col>
                                <Col span={11} offset={1}>
                                    <FormItem
                                        label="培训后获得技能"
                                        {...FormItemLayout()}
                                    >
                                        {getFieldDecorator('train_ppe')(
                                            <Input placeholder="填写培训后可获得技能"/>
                                        )}
                                    </FormItem>
                                    <FormItem
                                        label="培训需要的装备"
                                        {...FormItemLayout()}
                                    >
                                        {getFieldDecorator('train_equip')(
                                            <Input placeholder="填写培训需要的装备"/>
                                        )}
                                    </FormItem>
                                    <FormItem
                                        {...FormItemLayout()}
                                        label="阅览图片"
                                    >
                                        {getFieldDecorator('browse_img', {
                                            valuePropName: 'fileList',
                                            getValueFromEvent: this.normFile,
                                            rules: [{ required: true, message: '请上传阅览图片' }],
                                            initialValue: [],
                                        })(
                                            <Upload
                                                style={{ display: "inline-block" }}
                                                action={config.serverUrl + api.ImageUpload}
                                                listType="picture"
                                                name="image"
                                                accept='image/jpeg, image/jpg, image/png'
                                                beforeUpload={app.beforeUpload}
                                                data={{
                                                    indexno: app.getData('indexno'),
                                                    account: app.getData('account'),
                                                    token: app.getData('token'),
                                                    upload_type: 'train',
                                                }}
                                            >
                                                <Button disabled={(getFieldValue("browse_img") || []).length >= 1}>
                                                    <Icon type="cloud-upload"/> 上传图片
                                                </Button>
                                            </Upload>
                                        )}
                                        <span className="ant-form-text"> 只可以上传一张</span>
                                    </FormItem>
                                    <FormItem
                                        {...FormItemLayout()}
                                        label="详情图片"
                                    >
                                        {getFieldDecorator('details_img', {
                                            valuePropName: 'fileList',
                                            getValueFromEvent: this.normFile,
                                            rules: [{ required: true, message: '请上传详情图片' }],
                                            initialValue: [],
                                        })(
                                            <Upload
                                                className="upload-list-inline"
                                                action={config.serverUrl + api.ImageUpload}
                                                listType="picture"
                                                name="image"
                                                accept='image/jpeg, image/jpg, image/png'
                                                beforeUpload={app.beforeUpload}
                                                data={{
                                                    indexno: app.getData('indexno'),
                                                    account: app.getData('account'),
                                                    token: app.getData('token'),
                                                    upload_type: 'train',
                                                }}
                                            >
                                                <Button disabled={(getFieldValue("details_img") || []).length >= 8}>
                                                    <Icon type="cloud-upload"/> 上传图片
                                                </Button>
                                            </Upload>
                                        )}
                                        <span className="ant-form-text"> 最多上传8张图片</span>
                                    </FormItem>
                                    <FormItem
                                        label="是否颁发证书"
                                        {...FormItemLayout()}
                                    >
                                        {getFieldDecorator('is_certificate', {
                                            rules: [{ required: true, message: '请选择是否颁发证书' }],
                                        })(
                                            <Radio.Group>
                                                <Radio value="1">是</Radio>
                                                <Radio value="0">否</Radio>
                                            </Radio.Group>
                                        )}
                                    </FormItem>
                                </Col>
                                <Col span={24}>
                                    <FormItem
                                        label="培训内容"
                                        labelCol={{ span: 3 }}
                                        wrapperCol={{ span: 20, offset: 1 }}
                                    >
                                        {getFieldDecorator('train_content', {
                                            validateTrigger: 'onBlur',
                                            initialValue: BraftEditor.createEditorState(null),
                                            rules: [{
                                                required: true,
                                                validator: (_, value, callback) => {
                                                    if (value.isEmpty()) {
                                                        callback('请输入新闻内容')
                                                    } else {
                                                        callback()
                                                    }
                                                }
                                            }],
                                        })(
                                            <BraftEditor
                                                style={{ border: '1px solid #eee' }}
                                                excludeControls={excludeControls}
                                                extendControls={extendControls}
                                                stripPastedStyles={true}
                                                placeholder="请输入新闻内容"
                                            />
                                        )}
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={8} style={{ textAlign: "right" }}>
                                    <Button onClick={() => this.handleBack()}>返回</Button>
                                </Col>
                                {
                                    train_id ? [
                                        (<Col key="1" span={8} style={{ textAlign: "center" }}>
                                            <Button type="primary" loading={update_loading}
                                                    htmlType="submit">修改</Button>
                                        </Col>),
                                        (<Col key="2" span={8}>
                                            <Button type="primary"
                                                    onClick={() => this.openSelPlayerModal()}>添加培训人员</Button>
                                        </Col>),
                                    ] : [
                                        (<Col key="1" span={8} style={{ textAlign: "center" }}>
                                            <Button type="primary" htmlType="submit">下一步</Button>
                                        </Col>),
                                        (<Col key="2" span={8}>
                                            <Button onClick={() => this.handleReset()}>重新填写</Button>
                                        </Col>),
                                    ]
                                }
                            </Row>
                        </Form>
                    </div>
                    <Modal
                        visible={model_visible}
                        onCancel={this.closeSelPlayerModal}
                        onOk={this.handleSelPlayerSuccess}
                        title={<div>
                            选择培训人员
                            <span style={{ color: '#888', fontSize: 12, marginLeft: '1rem' }}>
                                <Icon type="info-circle" style={{ fontSize: 14, marginRight: 10 }}/>
                                由于数据量较大，可能导致加载速度较慢，请您耐心等候~
                            </span>
                        </div>}
                        maskClosable={false}
                        destroyOnClose={true}
                        keyboard={false}
                        className="notice-release-send-modal"
                        width="100%"
                        style={{ top: 0, height: '100vh', minWidth: 1200 }}
                        bodyStyle={{ height: 'calc(100vh - 108px)', overflow: 'auto' }}
                        confirmLoading={submit_loading}
                    >
                        {
                            grade ? (
                                <PlayerSelector type="train" grade={grade} onRef={this.onPlayerSelectorRef}/>) : null
                        }
                    </Modal>
                </div>
            </div>
        )
    }
}

export default Form.create()(NTrainRelease)



// WEBPACK FOOTER //
// ./src/routes/notice/NTrainRelease.jsx